export default theme => ({
  root: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(0)
  },
  content: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.border}`,
    borderRadius: '3px',
  },
  controlButtons: {
    marginLeft: theme.spacing(3),
  },
  refreshButton: {},
  controlButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: -theme.spacing(8),
    marginRight: -theme.spacing(1),
  }
});

